import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import MatchedPairReport from './MatchedPairReport';
import { getMatchedPairReport } from '../../actions/reports';

export class MatchedPairReportContainer extends React.Component {
  static propTypes = {
    orderId: PropTypes.string.isRequired,
    matchedPairReportData: PropTypes.object.isRequired,
    getMatchedPairReportAction: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { orderId, getMatchedPairReportAction } = this.props;
    const token = storeWithExpiration.get('token');
    getMatchedPairReportAction(token, orderId);
  };

  render() {
    const {
      matchedPairReportData,
    } = this.props;
    return (
      <MatchedPairReport
        matchedPairReportData={matchedPairReportData}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { orderId } = props.params;
  const { account, reports } = state;
  const matchedPairReportData = reports.get('matchedPairReport');
  return {
    account,
    orderId,
    matchedPairReportData,
  };
};

export default connect(
  mapStateToProps,
  {
    getMatchedPairReportAction: getMatchedPairReport,
  }
)(MatchedPairReportContainer);
